import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "aub",
  role: "status",
  "aria-live": "polite"
}
const _hoisted_2 = ["disabled"]

import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import { appUpdateAvailable, applyAppUpdate, checkForAppUpdate } from '@/composables/useAppUpdate'
import { onRealtimeRecovered } from '@/composables/useConversationRealtime'


export default /*@__PURE__*/_defineComponent({
  __name: 'AppUpdateBanner',
  setup(__props) {

// Avisa que há deploy novo enquanto o app está aberto (substitui o botão "Atualizar" do cabeçalho). A conferência é
// feita quando a aba volta a ficar visível e quando a conexão em tempo real volta — sem polling. "Depois" esconde até
// o próximo carregamento; a versão nova entra de qualquer jeito no próximo recarregar/login.
const store = useStore()
const dismissed = ref(false)
const applying = ref(false)
const visible = computed(() => appUpdateAvailable.value && !dismissed.value && !!store.getters.isLoggedIn)

function apply() {
  applying.value = true
  void applyAppUpdate()
}

function onVisible() {
  if (document.visibilityState === 'visible') void checkForAppUpdate()
}

let stopRecovered: (() => void) | null = null
onMounted(() => {
  document.addEventListener('visibilitychange', onVisible)
  stopRecovered = onRealtimeRecovered(() => { void checkForAppUpdate() })
})
onBeforeUnmount(() => {
  document.removeEventListener('visibilitychange', onVisible)
  stopRecovered?.()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "aub" }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _cache[1] || (_cache[1] = _createElementVNode("svg", {
              width: "16",
              height: "16",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2.2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "aria-hidden": "true"
            }, [
              _createElementVNode("polyline", { points: "23 4 23 10 17 10" }),
              _createElementVNode("path", { d: "M20.49 15a9 9 0 1 1-2.12-9.36L23 10" })
            ], -1)),
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "aub-text" }, "Saiu uma versão nova do WootDash.", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "aub-apply",
              disabled: applying.value,
              onClick: apply
            }, _toDisplayString(applying.value ? 'Atualizando…' : 'Atualizar agora'), 9, _hoisted_2),
            _createElementVNode("button", {
              type: "button",
              class: "aub-later",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (dismissed.value = true))
            }, "Depois")
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})